import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import '../styles/ToolProfile.css';
import backarrow from '../resources/back-arrow.svg';
import LoadingPage from '../components/LoadingPage';
import StudentCard from '../components/StudentCard';
import ErrorPage from '../components/ErrorPage';

const ToolProfile = () => {
    const navigate = useNavigate();
    const [tool, setTool] = useState(null);
    const [trainedStudents, setTrainedStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { id } = useParams();
    const API_URL = process.env.REACT_APP_API_URL;

    // Fetch tool data
    useEffect(() => {
        const fetchTool = async () => {
            try {
                const toolResponse = await axios.get(`${API_URL}/api/tools/${id}`);
                setTool(toolResponse.data);
            } catch (err) {
                setError(err);
            }
        };

        fetchTool();
    }, [id, API_URL]);

    // Fetch students data only after tool data is loaded
    useEffect(() => {
        const fetchStudents = async () => {
            if (!tool || !tool.list_of_trained_students) return;

            try {
                const response = await axios.get(`${API_URL}/api/students`);
                const fetchedStudents = response.data;
        
                const filteredTrainedStudents = fetchedStudents.filter(student => 
                    tool.list_of_trained_students.some(trainedStudent => 
                        trainedStudent.user_id === student.user_id
                    )
                );
                
                setTrainedStudents(filteredTrainedStudents);
            } catch (err) {
                setError(err);
            }
        };

        fetchStudents();
        setLoading(false);
    }, [tool, API_URL]);

    if (loading) return <LoadingPage />;
    if (error) return <ErrorPage />;
    if (!tool) return <LoadingPage />;

    return (
        <div>
            <Header />
            <div className="back-button" onClick={() => navigate('/view-tools')}>
                <img src={backarrow} alt="Go Back" />
                <span>Go Back</span>
            </div>
            <div className="tool-view">
                <h1>{tool.tool_name}</h1>
                <div className="tool-profile-container">
                    {tool.imageUrl && (
                        <img src={tool.imageUrl} alt={tool.tool_name} className="tool-image-profile" />
                    )}
                    <div className="tool-details">
                        <p><strong>Model:</strong> {tool.tool_model}</p>
                        <p><strong>Category:</strong> {tool.tool_category}</p>
                        <p><strong>Location:</strong> {tool.tool_location}</p>
                        <p><strong>Restriction:</strong> {tool.restriction === 'safe' ? 'No Adult Supervision Needed' : tool.restriction === 'cautious' ? 'Adult Supervision Needed' : 'Not Allowed For Student Use'}</p>
                    </div>
                </div>
            </div>
            <div className="students-container">
                <h3>Trained Students</h3>
                <div className="students-grid">
                    {trainedStudents.length > 0 ? (
                        trainedStudents.map((student) => (
                            <StudentCard key={student.user_id} student={student} />
                        ))
                    ) : (
                        <p>No trained students found for this tool.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ToolProfile;